import React from 'react';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
}
export function PageHeader({
  title,
  subtitle,
  backgroundImage
}: PageHeaderProps) {
  return <div className="relative h-[48vh] min-h-[360px] w-full flex items-end justify-center overflow-hidden" data-id="element-227">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full" data-id="element-228">
        <img src={backgroundImage} alt={title} className="object-cover w-full h-full scale-[1.02]" data-id="element-229" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/40 via-navy/30 to-navy/75" data-id="element-230" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A2744]/50 via-transparent to-transparent" data-id="element-231" />
        {/* Vignette effect */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_50%,rgba(26,39,68,0.3)_100%)] pointer-events-none" data-id="element-232" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 pb-18" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.4, 0, 0.2, 1]
      }} className="flex items-center justify-center gap-5 mb-5" data-id="element-234">
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-sand/50" data-id="element-235"></div>
          <span className="text-sand-light text-[11px] font-sans font-medium tracking-[0.35em] uppercase" data-id="element-236">
            {subtitle}
          </span>
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-sand/50" data-id="element-237"></div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.12,
        ease: [0.4, 0, 0.2, 1]
      }} className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-medium tracking-tight" data-id="element-238">
          {title}
        </motion.h1>
      </div>
    </div>;
}